export default __webpack_public_path__ + "static/media/Karlsruhe_Institute_of_Technology.51462cbe.png";